module.exports = __webpack_public_path__ + "img/config.eba8326d.png";